module.exports = __webpack_public_path__ + "img/xero-connect-btn.cddfa8e4.svg";